const GET_PAGES = `
  query {
    listingData: getPages {
      id,
      name
    }
  }
`;

export { GET_PAGES };
